import React from "react";
import { Paper, Box, Typography, Grid } from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SpeedIcon from "@mui/icons-material/Speed";
import { ClientStats } from "shared/types";

interface StatsSectionProps {
  stats: ClientStats;
}

interface StatItemProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const StatItem: React.FC<StatItemProps> = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      p: 2,
      backgroundColor: "rgba(23, 139, 142, 0.05)",
      borderRadius: 2,
    }}
  >
    <Box sx={{ color: "#178B8E", mb: 1 }}>{icon}</Box>
    <Typography variant="h6" fontWeight={700} color="text.primary">
      {value}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

const StatsSection: React.FC<StatsSectionProps> = ({ stats }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={600} mb={2}>
        My Stats
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <StatItem
            icon={<PetsIcon />}
            label="Total Bookings"
            value={stats.totalBookings.toString()}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <StatItem
            icon={<StarIcon />}
            label={`Rating (${stats.reviewCount} reviews)`}
            value={stats.rating.toFixed(1)}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <StatItem
            icon={<SpeedIcon />}
            label="Response Rate"
            value={`${stats.responseRate}%`}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <StatItem
            icon={<CheckCircleIcon />}
            label="Background Check"
            value={stats.backgroundCheckCompleted ? "Completed" : "Pending"}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default StatsSection;
